<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.username"
      appPrimengInputText
      pInputText
      placeholder="Nazwa użytkownika" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.email"
      appPrimengInputText
      pInputText
      placeholder="Adres e-mail"
      type="email" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <div class="flex">
      <p-password
        [fluid]="true"
        [formControl]="form.controls.password"
        appPrimengPassword
        autocomplete="off"
        class="mr-3 flex-1"
        placeholder="Wprowadź hasło" />

      <p-button
        (onClick)="handleGeneratePasswordClick()"
        [text]="true"
        appPrimengButton
        label="Generuj hasło"
        type="button" />
    </div>
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.firstName"
      appPrimengInputText
      pInputText
      placeholder="Imię" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.lastName"
      appPrimengInputText
      pInputText
      placeholder="Nazwisko" />
  </app-form-control>

  <app-form-control inputId="6e3ef33d-c139-4102-8a86-56333412769d">
    <app-checkbox-with-label inputId="6e3ef33d-c139-4102-8a86-56333412769d">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.regulations" />

      <app-regulations-checkbox-label label />
    </app-checkbox-with-label>
  </app-form-control>

  <app-form-control inputId="afee1052-7adf-4cd9-94a9-7386a092e955">
    <app-checkbox-with-label inputId="afee1052-7adf-4cd9-94a9-7386a092e955">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.newsletter" />

      <app-newsletter-checkbox-label label />
    </app-checkbox-with-label>
  </app-form-control>

  <app-privacy-policy-clause />

  <div class="flex justify-center">
    <app-form-control>
      <app-re-captcha [formControl]="form.controls.recaptcha" />
    </app-form-control>
  </div>

  <p-button
    [disabled]="form.invalid"
    [fluid]="true"
    appPrimengButton
    label="Zarejestruj"
    size="large"
    type="submit" />
</form>
